import React from 'react';
import Button from '../../components/Form/Button';

interface ActiveCrewInfoBannerProps {
  onQuickPrint: () => void;
}

const ActiveCrewInfoBanner: React.FC<ActiveCrewInfoBannerProps> = ({ onQuickPrint }) => (
  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
    <div className="flex justify-between items-start">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="mr-3">
          <p className="text-sm text-blue-700">
            يتم إنشاء هذه القائمة تلقائياً من أحدث تغييرات الطاقم. يتم عرض الموظفين الذين لديهم حالة "تسجيل دخول" أو "متابعة" فقط.
            تتحدث القائمة في الوقت الفعلي عند إجراء تغييرات على الطاقم. استخدم زر التحديث للتأكد من حصولك على أحدث البيانات.
          </p>
        </div>
      </div>
      <Button
        type="button"
        variant="primary"
        onClick={onQuickPrint}
        className="mr-4 whitespace-nowrap"
      >
        طباعة سريعة للقائمة
      </Button>
    </div>
  </div>
);

export default ActiveCrewInfoBanner;
